import { ReactNode } from "react";
import {
  InfoIconHoverAlert,
  InfoIconHoverAlertProps,
} from "shared/components/InfoIconHoverAlert";
import { Flex, Text, tokens } from "shared/components/Spor";

type InfoHeaderProps = {
  title: string;
  headerContent?: ReactNode;
  titleXPadding?: string;
  tooltipWidth?: string | number;
} & InfoIconHoverAlertProps;

/**
 * Reusable container for section headers that shows a title,
 * optional right-aligned content, and an info icon with hover alert.
 */
export const InfoHeader = ({
  title,
  headerContent,
  titleXPadding,
  tooltipWidth,
  ...props
}: InfoHeaderProps) => (
  <Flex
    direction="row"
    gap={tokens.default.size.spacing[4]}
    width="100%"
    alignItems="center"
  >
    <Text variant="md" fontWeight="bold" px={titleXPadding} mt={0.5}>
      {title}
    </Text>
    <Flex
      ml="auto"
      alignItems="center"
      gap={tokens.default.size.spacing[1]}
      px={titleXPadding}
    >
      {headerContent}
      <InfoIconHoverAlert width={tooltipWidth} {...props} />
    </Flex>
  </Flex>
);
